//bao migrate skip
import * as ko from "knockout";
function TreeNodeViewModel(serverNode?, parentNode?) {
    var self = this;
    self.Nodes = ko.observableArray([]);
    self.Loaded = ko.observable(true);
    self.Expanded = ko.observable(false);
    self.Loading = ko.observable(false);
    self.Count = ko.observable();
    self.CountVisible = ko.observable(false);
    self.Level = ko.observable(0);
    self.IsAllowed = ko.observable(true);
    self.NodeIcon = ko.observable();
    self.HasNodes = ko.computed(function () {
        return self.Nodes() != null && self.Nodes().length > 0;
    });
    self.Icon = ko.computed(function () {
        if (self.Expanded() && self.HasNodes()) {
            return "fal fa-minus-square";
        }
        else if (!self.Expanded() && !self.Loaded() || !self.Expanded() && self.Loaded() && self.HasNodes()) {
            return "fal fa-plus-square";
        }
        else if (self.Loading() == true) {
            return "fal fa-clock";
        }
        else {
            return "fa empty";
        }
    });
    var childrenNodes = serverNode.Nodes;
    delete serverNode.Nodes;
    ko.map.fromJS(serverNode, self);
    var koChildrenNodes = [];
    if (childrenNodes != null && childrenNodes.length > 0) {
        ko.utils.arrayForEach(childrenNodes, function (item) {
            var newTreeNode = new TreeNodeViewModel(item, self);
            koChildrenNodes.push(newTreeNode);
        });
    }
    self.Nodes(koChildrenNodes);
    self.Parent = parentNode;
}
function BuildTreeNodeViewModel(serverNodes) {
    var koNodes = ko.map.fromJS(serverNodes);
    var rekbuildKoNodes = function (nodes, parent) {
        ko.utils.arrayForEach(nodes(), function (item) {
            var newNode = new TreeNodeViewModel();
            ko.map.fromJS(newNode, item);
            nodes[nodes.length] = newNode;
            rekbuildKoNodes(newNode.Nodes, newNode);
        });
    };
}
export default TreeNodeViewModel;